import { SessionService } from '@thoughtspot/session-service';
import { shouldNotShowGlobalBanner } from './routes-util';

export const isLeftPanelVisible = (
    isOverlayPanel: boolean,
    isGlobalNavHidden: boolean,
    isNavigationV3Enabled: boolean,
    isInsightsPage: boolean,
    sessionService: SessionService,
) => {
    return (
        !isOverlayPanel &&
        !isGlobalNavHidden &&
        !(
            sessionService.hideHomepageLeftNav(isNavigationV3Enabled) &&
            isInsightsPage
        )
    );
};

export const isGlobalBannerVisible = (
    pathname: string,
    isTrialVersionEnabled: boolean,
    isSlackBotEnabled: boolean,
    isServiceWorkerEnabled: boolean,
) => {
    return (
        !shouldNotShowGlobalBanner(pathname) &&
        (isTrialVersionEnabled || isSlackBotEnabled || isServiceWorkerEnabled)
    );
};
